export const DOCTOR_TYPE = 'doctor';
export const TEST_PROFILE_TYPE = 'profile';
export const TEST_RESULT_TYPE = 'test_result';
export const TEST_REPORT_TYPE = 'report';
export const TEST_PANEL_TYPE = 'panel';
export const TEST_FAILURE_CLASSIFICATION_TYPE = 'test_failure_classification';
export const TEST_RESULT_ATTACHMENT_TYPE = 'test_result_attachment';
export const INTERVENTION_ANALYTE_TYPE = 'intervention_analyte';
export const ANALYTE_RESULT_TYPE = 'analyte_result';
export const HEALTH_INSIGHTS_TYPE = 'health_insight';
export const HEALTH_INSIGHTS_CATEGORY_TYPE = 'health_insight_category';
export const HEALTH_INSIGHTS_TAG_TYPE = 'health_insight_tag';
export const TEST_REQUEST_TYPE = 'test_request';
export const REPORT_ANALYTE_COMMENT_TYPE = 'report_analyte_comment';
export const FORECAST_TYPE = 'forecast';
export const ROLE_TYPE = 'role';
//# sourceMappingURL=helpers.js.map